import { localizeNumber } from "../../../../helpers";
import ibsStore from "../../../Stores/IbsSurveyStore"
import store from "../../../Stores/SurveyStore"
import { sumOfInternalTeamsNAV } from "../../../../ibsHelper";
import { NumberFormat } from "../../../../Enums/constants";
import { columnCalculation, calculationsForProvided } from "../../../../Helpers/TableCalculationHelper";
import { loadDefaultTableErrors } from "../../../../Helpers/TableHelper";
import { formatNumber } from "../../../../Helpers/General/FormatHelper";

export function createFrontOfficeData(props, referenceToTable, listOfHeaderRows, dataObj) {
    //hope this only will not get retriggered when we update the overriden stuff
    //  Need to overwrite this to keep things correct
    store.overridenWarnings = {};
    store.overridenErrors = {};
    if (!ibsStore.allTableResponses[props.tableName]) return {}
    //compile list of errors
    loadDefaultTableErrors(props.tableName);

    let includeTotalRow = props.includeTotalRow;

    var rawData = ibsStore.allTableResponses[props.tableName]
    if (rawData == [] || typeof rawData === "undefined" || rawData === undefined) return {};
    referenceToTable = rawData
    rawData = calculationsForProvided(rawData, props);
    dataObj = rawData.slice();

    let totalRow = {};

    totalRow['NumFTE'] = formatNumber(NumberFormat.DECIMAL1, columnCalculation("NumFTE", true, props));
    totalRow['Costs'] = formatNumber(NumberFormat.DECIMAL1, columnCalculation("Costs", true, props));
    totalRow['TeamName'] = "Total";
    let sumNAVTotal = 0
    let expensesTable = ibsStore.allTableResponses['FrontOffice']
    expensesTable.forEach(team => {
        sumNAVTotal = sumNAVTotal + sumOfInternalTeamsNAV(team.RowID);
    })
    totalRow['NAV'] = formatNumber(NumberFormat.MONEYMILLION, sumNAVTotal);
    totalRow['del'] = "";
    totalRow['RowID'] = "Total";
    totalRow['__children'] = null;
    //rowJustAdded = referenceToTable.findIndex((element) => element.RowID === ibsStore.lastRowAdded)

    if (Object.keys(totalRow).length > 0) {
        dataObj.push(totalRow);
        listOfHeaderRows.push(dataObj.length - 1);
    }

    dataObj.forEach((elem) => {
        if (elem.hasOwnProperty('NumFTE')) {
            elem.NumFTE = localizeNumber(elem.NumFTE);
        }
        if (elem.hasOwnProperty('Costs')) {
            elem.Costs = localizeNumber(elem.Costs);
        }

    });
    return [dataObj, listOfHeaderRows, referenceToTable];
}

export function handleFrontOfficeData(props, referenceToTable, listOfHeaderRows, dataObj) {
    let frontOfficeObj = createFrontOfficeData(props, referenceToTable, listOfHeaderRows, dataObj)
    let data = frontOfficeObj[0]
    let headers = frontOfficeObj[1]
    referenceToTable = frontOfficeObj[2]
    return [data, referenceToTable, headers]
}

export function getHiddenFrontOfficeColumns() {
    let hideCols = []
    if (![3, 6].includes(ibsStore.currentSurvey.EnhancedInternalID)) {
        hideCols.push(3)
        hideCols.push(4)
        hideCols.push(5)
        hideCols.push(6)
    }
    return hideCols
}
